module.exports = __webpack_public_path__ + "img/potion_15.bd18244f.png";